
import { Component, Vue } from 'vue-property-decorator'
import { apiAiConfigGet, apiAiConfigSet } from '@/api/setting'

@Component
export default class AiSetting extends Vue {
  form: any = {
    deepseek_api_key: '',
    deepseek_model: 'deepseek-chat',
    input_cache_hit_price: '0.5',
    input_cache_miss_price: '2',
    output_price: '8',
    yop_merchant_no: '',
    yop_parent_merchant_no: '',
    yop_app_key: '',
    yop_isv_private_key: ''
  }

  rules = {
    deepseek_api_key: [{ required: true, message: '请输入 DeepSeek API Key', trigger: 'blur' }],
    deepseek_model: [{ required: true, message: '请输入模型名称', trigger: 'blur' }]
  }

  async loadConfig () {
    const res = await apiAiConfigGet()
    this.form = { ...this.form, ...res }
  }

  onSubmit (formName: string) {
    const refs = this.$refs[formName] as HTMLFormElement
    refs.validate(async (valid: boolean) => {
      if (!valid) return
      await apiAiConfigSet({ ...this.form })
      this.$message.success('保存成功')
      this.loadConfig()
    })
  }

  created () {
    this.loadConfig()
  }
}
